import { BarChart } from "../svg/BarChart";
import { AbsLogo } from "../svg/AbsLogo";
import { DeveloperGuide } from "../svg/DeveloperGuide";
import { Notifications } from "../svg/Notifications";
import { School } from "../svg/School";
import { List } from "../svg/List";
import { Person } from "../svg/Person";
import { Location } from "../svg/Location";
import { Instant } from "../svg/Instant";
import { BookmarkStar } from "../svg/BookmarkStar";
import { Search } from "../svg/Search";
import { History } from "../svg/History";
import { Persons } from "../svg/Persons";
import { JSX } from "react";
import { Agenda } from "../svg/Agenda";
import { Clock } from "../svg/Clock";

export function getSvg(svgName: string): JSX.Element | null {
    switch (svgName) {
        case "AbsLogo":
            return <AbsLogo />;
        case "BarChart":
            return <BarChart />;
        case "BookmarkStar":
            return <BookmarkStar />;
        case "DeveloperGuide":
            return <DeveloperGuide />;
        case "Notifications":
            return <Notifications />;
        case "School":
            return <School />;
        case "List":
            return <List />;
        case "Person":
            return <Person />;
        case "Location":
            return <Location />;
        case "Instant":
            return <Instant />;
        case "Search":
            return <Search />;
        case "History":
            return <History />;
        case "Persons":
            return <Persons />;
        case "Agenda":
            return <Agenda />;
        case "Clock":
            return <Clock />;
        default:
            return null;
    }
}
